const hocAux = (props) => props.children;

export default hocAux;
